module["exports"] = [
  "#{Name.last_name} #{suffix}",
  "#{Name.last_name}-#{Name.last_name}",
  "#{Name.last_name}, #{Name.last_name} og #{Name.last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/company/name.js
// module id = 1518
// module chunks = 1